// Nome do cookie que sinaliza logout deliberado para todos os produtos do
// domínio compartilhado. Vive em módulo próprio (e não em auth-session-expiry)
// porque cognito-storage-migration também precisa lê-lo: mantê-lo no
// auth-session-expiry criaria import circular entre os dois.
export const LOGOUT_MARKER_COOKIE = 'abbiamo.logoutMarker';
